import React, {Component} from "react";
import Glob from "../../libs/Glob.mjs";
import Annunci from "./Annunci.mjs";
import WholeWeek from "./WholeWeek.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import Calendar from "./Calendar.mjs";
import AutoIcon from "../../controls/AutoIcon.mjs";
import "./Details.css";
import "../SubNavBar.css";
import Meteo from "./Meteo.mjs";
import AddressBook from "./AddressBook.mjs";
import Links from "./Links.mjs";
import RecyclingRules from "./RecyclingRules.mjs";
import AboutPage from "./AboutPage.mjs";
import AppAboutIcon from "../../media/assets/AppAboutIcon.mjs";

const Details = class extends Component {
	constructor(props) {
		super(props);
		this.state = {}
		this.pane = this.pane.bind(this);
		this.selectPane = this.selectPane.bind(this);
		this.uid = Glob.generateUid('Details');
	}
	componentDidMount() {
		Glob.register( 'currentPage', mo => {
			const p = mo?.params?.pane;
			if ( p && p !== this.state.pane ) this.setState({ pane: p });
		}, this.uid);
		const p = Glob.getPageParam('pane') || 'calendar';
		if ( p !== this.state.pane ) this.setState({ pane: p });
	}
	componentWillUnmount() {
		Glob.deregister( this.uid );
	}
	selectPane(x) {
		Glob.setCurrentPageParam('pane', x);
	}
	pane(x) {
		if ( typeof x === 'undefined' ) x = Glob.getPageParam("pane") || 'calendar';
		switch ( x ) {
			case 'meteo': return (
				<>
					<h2 className={"title"}>
						<AutoIcon value={"meteo"} />
						<TextLabel value={"Weather forecasts"} />
					</h2>
					<Meteo qtdays={7} />
				</>
			);
			case 'directory': return  (
				<>
					<h2 className={"title"}>
						<AutoIcon value={"directory"} />
						<TextLabel value={"Directory"} />
					</h2>
					<AddressBook />
				</>
			);
			case 'links': return <Links/>;
			case 'recycle': return (
				<>
					<h2 className={"title"}>
						<AutoIcon value={"trash"} />
						<TextLabel value={"Recycling rules"} />
					</h2>
					<RecyclingRules/>
				</>
			);
			case 'about': return <AboutPage />;
			default: return (
				<div className="Calendar">
					<h2 className={"title"}>
						<AutoIcon value={"calendar"} />
						<TextLabel value={"Calendar"} />
					</h2>
					<div>
						<Annunci />
						<WholeWeek />
					</div>
					<div>
						<h3>
							<TextLabel value={"Dates"} />
						</h3>
						<Calendar max={60}/>
					</div>
				</div>
			);
		}
	}
	render() {
		return (
			<div className={"Details"}>
				<div className="SubNavBar">
					<div
						onClick={ ()=>{ this.selectPane('calendar'); } }
						className={ this.state.pane === 'calendar' ? 'active' : 'inactive' }
					>
						<AutoIcon value={"calendar"} />
						<span>
							<TextLabel value={"Calendar"} />
						</span>
					</div>
					<div
						onClick={ ()=>{ this.selectPane('meteo'); } }
						className={ this.state.pane === 'meteo' ? 'active' : 'inactive' }
					>
						<AutoIcon value={"meteo"} />
						<span>
							<TextLabel value={"Meteo"} />
						</span>
					</div>
					<div
						onClick={ ()=>{ this.selectPane('directory'); } }
						className={ this.state.pane === 'directory' ? 'active' : 'inactive' }
					>
						<AutoIcon value={"directory"} />
						<span>
							<TextLabel value={"Directory"} />
						</span>
					</div>
					<div
						onClick={ ()=>{ this.selectPane('links'); } }
						className={ this.state.pane === 'links' ? 'active' : 'inactive' }
					>
						<AutoIcon value={"link"} />
						<span>
							<TextLabel value={"Links"} />
						</span>
					</div>
					<div
						onClick={ ()=>{ this.selectPane('recycle'); } }
						className={ this.state.pane === 'recycle' ? 'active' : 'inactive' }
					>
						<AutoIcon value={"trash"} />
						<span>
							<TextLabel value={"Recycle"} />
						</span>
					</div>
					<div
						onClick={ ()=>{ this.selectPane('about'); } }
						className={ 'minor '+(this.state.pane === 'about' ? 'active' : 'inactive') }
					>
						<AppAboutIcon />
						<span>
							<TextLabel value={"About"} />
						</span>
					</div>
				</div>
				<div
					className={"SubNavContent"}
					key={ this.state.pane }
				>
					{ this.pane(this.state.pane) }
				</div>
			</div>
		)
	}
}

export default Details;